module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-8-inverse-6a101c4e10f985070c8889cf2e8b5a16.png";